const B_SIZE = Float32Array.BYTES_PER_ARRAY;

let ptVertices;
export const smoke = (
    gl,
    program,
    canvas,
    densities,
    effect,
    pointBuffer,
    colorBuffer
) => {
    if (!pointBuffer.current) {
        pointBuffer.current = gl.createBuffer();
        ptVertices = new Float32Array(new Array(densities.length).fill(0).flatMap(
            (density, pt) => {
                let x = pt%66;
                let y = (pt-x)/66;
                return [
                    -1 + 2*(x/64),
                    -1 + 2*(1 - y/64),
                ];
            }));
        gl.bindBuffer(gl.ARRAY_BUFFER, pointBuffer.current);
        gl.bufferData(gl.ARRAY_BUFFER, ptVertices, gl.STATIC_DRAW);
        
        var aPosition = gl.getAttribLocation(program, 'aPosition');
        gl.enableVertexAttribArray(aPosition);
        gl.vertexAttribPointer(aPosition, 2, gl.FLOAT, false, 0, 0);

        colorBuffer.current = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer.current);
        gl.bufferData(gl.ARRAY_BUFFER, densities, gl.STATIC_DRAW);
        
        var vertColor = gl.getAttribLocation(program, 'vertColor');
        gl.enableVertexAttribArray(vertColor);
        gl.vertexAttribPointer(vertColor, 1, gl.FLOAT, false, 0, 0);
    } else {
        gl.bindBuffer(gl.ARRAY_BUFFER, pointBuffer.current);
        gl.bufferData(gl.ARRAY_BUFFER, ptVertices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer.current);
        gl.bufferData(gl.ARRAY_BUFFER, densities, gl.STATIC_DRAW);
    }
    return densities.length;
};

